var constant = {
  ID_SPLIT_FLAG: '__ID_SPLIT__',
  IMAGE_UPLOAD_PLACEHOLDER_CLASS_NAME: 'quill-plugin-image-upload-placeholder'
};
module.exports = constant;